export default {
    meta: {
        title: '鱼你在一起-创建拓店任务',
        url: '/fishtogether/tasklist',
        urlName: '鱼你拓店任务'
    }
};
